export default "__VITE_ASSET__128250a3__"